// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-radius: 10px !important;
  border: none;
  margin-top: 0;
}
@media (min-width: 991px) {
  ion-item {
    padding-inline: 3%;
  }
}
ion-item:not(:last-child) {
  margin-bottom: 12px;
}
ion-item.no-line {
  --border-color: transparent;
}

ion-input {
  --border: none !important;
  color: #fff;
  font-family: AppFont, sans-serif;
}

.no-line {
  border-bottom: 0px;
  --background: transparent;
}

.privacy {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #fff;
}
.privacy ion-button {
  padding: 0px;
  color: #fff;
  text-transform: capitalize;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  margin-bottom: 0;
  color: var(--ion-text-color);
}

.terms {
  margin-left: 0px;
  border: 1px solid #fff;
  border-radius: 10px;
}
.terms ion-checkbox {
  margin-right: 10px;
}
.terms ion-checkbox::part(label) {
  white-space: unset;
}
@media (min-width: 991px) {
  .terms {
    padding: 0;
  }
}

ion-checkbox {
  width: 19px;
  height: 19px;
  margin: 10px 10px 10px 0;
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
}
@media (min-width: 991px) {
  .stacked {
    left: 3%;
  }
}

ion-label {
  font-family: AppFontSemiBold;
  font-size: 14px;
  color: var(--ion-text-color);
  letter-spacing: 0.08em;
}

@media (min-width: 991px) {
  .name-row {
    padding-inline: 3%;
  }
}

.name-col {
  padding: 0;
}
@media (min-width: 991px) {
  .name-col .stacked {
    left: 0;
  }
  .name-col ion-item {
    padding-inline: 0;
  }
  .name-col:first-child {
    padding-right: 7px;
  }
  .name-col:last-child {
    padding-left: 7px;
  }
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: var(--color-black);
}
.input-age ion-input:first-child {
  border-right: 1px solid #cbd5e1;
}
.input-age ion-input:last-child {
  border-left: 1px solid #cbd5e1;
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

.wrapper {
  padding: 30px 15px 20px;
  margin: auto;
  max-width: 500px;
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 64px;
    font-size: 20px;
  }
}
.button-wrapper ion-button p {
  margin-top: 5px;
  font-family: AppFontBold, sans-serif;
  color: white;
  width: 75%;
}

.wrapper-modal {
  border: 2px solid var(--color-black);
  border-radius: 26px;
  height: 100%;
  position: relative;
  overflow: auto;
  background: #f6f1ef;
}
@media (max-width: 992px) {
  .wrapper-modal {
    margin-top: 25px;
    border-bottom: none;
    border-bottom-left-radius: 0px;
    border-bottom-right-radius: 0px;
  }
}
.wrapper-modal ion-item {
  --background: #f6f1ef;
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  width: 25px;
  height: 25px;
  z-index: 99;
}
@media (min-width: 991px) {
  .wrapper-modal .close-icon {
    display: none;
  }
}
.wrapper-modal .big-close-icon {
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 15px;
  width: 50px;
  height: 50px;
  z-index: 99;
}
@media (max-width: 992px) {
  .wrapper-modal .big-close-icon {
    display: none;
  }
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
  font-size: 15px;
  letter-spacing: 0.08em;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    font-family: AppFontBold, sans-serif;
    font-size: 32px;
    margin-bottom: 30px;
    padding-top: 25px;
  }
}
.wrapper-modal .subtitle-text {
  display: none;
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFont, sans-serif;
  padding: 10px;
  letter-spacing: 0.08em;
  text-wrap: balance;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    display: block;
    font-size: 20px;
    margin-bottom: 40px;
  }
}
.wrapper-modal .header-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    padding: 40px;
  }
}

.underline {
  --border-width: 0px;
  border: none !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sign-up/sign-up.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACE,6BAAA;AADF;;AAIA;EACE,QAAA;EACA,kBAAA;AADF;;AAIA;EACE,gCAAA;EACA,YAAA;EACA,aAAA;AADF;ACZE;EDUF;IAMI,kBAAA;EAAF;AACF;AAEE;EACE,mBAAA;AAAJ;AAGE;EACE,2BAAA;AADJ;;AAKA;EACE,yBAAA;EACA,WAAA;EACA,gCAAA;AAFF;;AAKA;EACE,kBAAA;EACA,yBAAA;AAFF;;AAKA;EACE,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,WAAA;AAHF;AAKE;EACE,YAAA;EACA,WAAA;EACA,0BAAA;AAHJ;;AAQA;EACE,eAAA;EACA,mBAAA;AALF;;AAQA;EACE,gBAAA;EACA,4BAAA;AALF;;AASA;EACE,gBAAA;EACA,sBAAA;EACA,mBAAA;AANF;AAQE;EACE,kBAAA;AANJ;AASE;EACE,kBAAA;AAPJ;ACpEE;EDiEF;IAcI,UAAA;EAPF;AACF;;AAUA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAPF;ACtFE;EDyFF;IAOI,QAAA;EANF;AACF;;AASA;EACE,4BAAA;EACA,eAAA;EACA,4BAAA;EACA,sBAAA;AANF;;AClGE;ED2GF;IAEI,kBAAA;EANF;AACF;;AASA;EACE,UAAA;AANF;AC5GE;EDoHE;IACE,OAAA;EALJ;EAOE;IACE,iBAAA;EALJ;EAQE;IACE,kBAAA;EANJ;EAQE;IACE,iBAAA;EANJ;AACF;;AAWE;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;AARJ;AAWE;EACE,+BAAA;AATJ;AAYE;EACE,8BAAA;AAVJ;;AAcA;EACE,yBAAA;EACA,gBAAA;AAXF;;AAcA;EACE,YAAA;EACA,mBAAA;AAXF;;AAcA;EAEI,uBAAA;EACF,YAAA;EACA,gBAAA;AAZF;;AAeA;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;AAZF;AAcE;EACE,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;AAbJ;ACnKE;ED2KA;IAQI,gBAAA;IACA,eAAA;EAZJ;AACF;AAcI;EACE,eAAA;EACA,oCAAA;EACA,YAAA;EACA,UAAA;AAZN;;AAiBA;EAOE,oCAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AApBF;AClLE;ED0LF;IAEI,gBAAA;IACA,mBAAA;IACA,8BAAA;IACA,+BAAA;EANF;AACF;AAcE;EACE,qBAAA;AAZJ;AAeE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAbJ;AC3ME;EDkNA;IASI,aAAA;EAZJ;AACF;AAeE;EACE,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AAbJ;ACnNE;EDyNA;IAUI,aAAA;EAZJ;AACF;AAeE;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;AAbJ;ACvOE;ED6OA;IASI,oCAAA;IACA,eAAA;IACA,mBAAA;IACA,iBAAA;EAXJ;AACF;AAcE;EACE,aAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAZJ;AC1PE;ED6PA;IAWI,cAAA;IACA,eAAA;IACA,mBAAA;EAVJ;AACF;AAaE;EACE,aAAA;AAXJ;ACpQE;ED8QA;IAGI,aAAA;EATJ;AACF;;AAaA;EACE,mBAAA;EACA,uBAAA;AAVF","sourcesContent":["@import '../../../theme/mixins';\n\nion-item.input-error {\n  margin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n  gap: 5px;\n  margin-bottom: 8px;\n}\n\nion-item {\n  --border-radius: 10px !important;\n  border: none;\n  margin-top: 0;\n\n  @include desktop {\n    padding-inline: 3%;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: 12px;\n  }\n\n  &.no-line {\n    --border-color: transparent;\n  }\n}\n\nion-input {\n  --border: none !important;\n  color: #fff;\n  font-family: AppFont, sans-serif;\n}\n\n.no-line {\n  border-bottom: 0px;\n  --background: transparent;\n}\n\n.privacy {\n  display: flex;\n  align-items: center;\n\n  font-size: 12px;\n  color: #fff;\n\n  ion-button {\n    padding: 0px;\n    color: #fff;\n    text-transform: capitalize;\n  }\n}\n\n\nion-note {\n  font-size: 12px;\n  padding-right: 10px;\n}\n\nion-item {\n  margin-bottom: 0;\n  color: var(--ion-text-color);\n}\n\n\n.terms {\n  margin-left: 0px;\n  border: 1px solid #fff;\n  border-radius: 10px;\n\n  ion-checkbox {\n    margin-right: 10px;\n  }\n\n  ion-checkbox::part(label) {\n    white-space: unset;\n  }\n\n  @include desktop {\n    padding: 0;\n  }\n}\n\nion-checkbox {\n  width: 19px;\n  height: 19px;\n  margin: 10px 10px 10px 0;\n}\n\n.stacked {\n  position: relative;\n  top: -10px;\n  left: 0%;\n  z-index: 2;\n\n  @include desktop {\n    left: 3%;\n  }\n}\n\nion-label {\n  font-family: AppFontSemiBold;\n  font-size: 14px;\n  color: var(--ion-text-color);\n  letter-spacing: 0.08em;\n}\n\n.name-row {\n  @include desktop {\n    padding-inline: 3%;\n  }\n}\n\n.name-col {\n  padding: 0;\n  @include desktop {\n    .stacked {\n      left: 0;\n    }\n    ion-item {\n      padding-inline: 0;\n    }\n\n    &:first-child {\n      padding-right: 7px;\n    }\n    &:last-child {\n      padding-left: 7px;\n    }\n  }\n}\n\n.input-age {\n  ion-input {\n    height: 100%;\n    text-align: center;\n    color: var(--color-black);\n  }\n\n  ion-input:first-child {\n    border-right: 1px solid #cbd5e1;\n  }\n\n  ion-input:last-child {\n    border-left: 1px solid #cbd5e1;\n  }\n}\n\nion-footer {\n  --background: transparent;\n  box-shadow: none;\n}\n\n.loading {\n  height: 50vh;\n  align-items: center;\n}\n\n.wrapper {\n\n    padding: 30px 15px 20px;\n  margin: auto;\n  max-width: 500px;\n}\n\n.button-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 100%;\n\n  ion-button {\n    width: 100%;\n\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n\n    @include desktop {\n      min-height: 64px;\n      font-size: 20px;\n    }\n\n    p {\n      margin-top: 5px;\n      font-family: AppFontBold, sans-serif;\n      color: white;\n      width: 75%;\n    }\n  }\n}\n\n.wrapper-modal {\n  @include mobile {\n    margin-top: 25px;\n    border-bottom: none;\n    border-bottom-left-radius: 0px;\n    border-bottom-right-radius: 0px;\n  }\n  border: 2px solid var(--color-black);\n  border-radius: 26px;\n  height: 100%;\n  position: relative;\n  overflow: auto;\n  background: #f6f1ef;\n\n  ion-item {\n    --background: #f6f1ef;\n  }\n\n  .close-icon {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 25px;\n    height: 25px;\n    z-index: 99;\n\n    @include desktop {\n      display: none;\n    }\n  }\n\n  .big-close-icon {\n    cursor: pointer;\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    width: 50px;\n    height: 50px;\n    z-index: 99;\n\n    @include mobile {\n      display: none;\n    }\n  }\n\n  .title-text {\n    width: 100%;\n    text-align: center;\n    color: var(--color-black);\n    text-transform: uppercase;\n    font-family: AppFontMedium, sans-serif;\n    font-size: 15px;\n    letter-spacing: 0.08em;\n    @include desktop {\n      font-family: AppFontBold, sans-serif;\n      font-size: 32px;\n      margin-bottom: 30px;\n      padding-top: 25px;\n    }\n  }\n\n  .subtitle-text {\n    display: none;\n    width: 100%;\n    text-align: center;\n    color: var(--color-black);\n    text-transform: uppercase;\n    font-family: AppFont, sans-serif;\n    padding: 10px;\n    letter-spacing: 0.08em;\n    text-wrap: balance;\n    @include desktop {\n      display: block;\n      font-size: 20px;\n      margin-bottom: 40px;\n    }\n  }\n\n  .header-block {\n    padding: 20px;\n    @include desktop {\n      padding: 40px;\n    }\n  }\n}\n\n.underline {\n  --border-width: 0px;\n  border: none !important;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
